

import { generateId } from '../utils/storage';

const SESSION_KEY = 'twiggy_session_id';
const SESSION_TIMESTAMP_KEY = 'twiggy_session_ts';
const SESSION_TIMEOUT = 30 * 60 * 1000; 

export class SessionManager {
  private sessionId: string | null = null;

  constructor() {
    this.initSession();
  }

  
  private initSession(): void {
    if (typeof sessionStorage === 'undefined') {
      this.sessionId = generateId();
      return;
    }

    const existingId = sessionStorage.getItem(SESSION_KEY);
    const lastActivity = sessionStorage.getItem(SESSION_TIMESTAMP_KEY);

    if (existingId && lastActivity) {
      const elapsed = Date.now() - parseInt(lastActivity, 10);
      if (elapsed < SESSION_TIMEOUT) {
        
        this.sessionId = existingId;
        this.updateTimestamp();
        return;
      }
    }

    
    this.sessionId = generateId();
    this.save();
  }

  
  getSessionId(): string {
    if (!this.sessionId) {
      this.initSession();
    }
    this.updateTimestamp();
    return this.sessionId!;
  }

  
  isValid(): boolean {
    if (typeof sessionStorage === 'undefined') return true;

    const lastActivity = sessionStorage.getItem(SESSION_TIMESTAMP_KEY);
    if (!lastActivity) return false;

    const elapsed = Date.now() - parseInt(lastActivity, 10);
    return elapsed < SESSION_TIMEOUT;
  }

  
  private updateTimestamp(): void {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
    }
  }

  
  private save(): void {
    if (typeof sessionStorage !== 'undefined' && this.sessionId) {
      sessionStorage.setItem(SESSION_KEY, this.sessionId);
      sessionStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
    }
  }

  
  reset(): void {
    this.sessionId = generateId();
    this.save();
  }

  
  touch(): void {
    this.updateTimestamp();
  }
}
